/* ==========================================================================
   MODULE: MEDICAL & ALLERGY INFO LIFECYCLES (medicalInfo.js)
   ========================================================================== */

export function initMedicalInfo() {
  const medSelect = document.getElementById('medIssues');
  const medDiv = document.getElementById('explainMedDiv');
  const allergySelect = document.getElementById('allergies');
  const allergyDiv = document.getElementById('explainAllergyDiv');

  const toggleMedicalSection = (selectElement, targetContainer, inputId) => {
    if (!selectElement || !targetContainer) return;
    
    selectElement.addEventListener('change', () => {
      // FIXED: Looks for your true HTML attribute value codes ("1" represents Yes)
      const selectedValue = (selectElement.value || '').trim();
      const hasCondition = selectedValue === '1';
      const explanationInput = document.getElementById(inputId);

      if (hasCondition) {
        // Display the explanation block element over container utility overrides
        targetContainer.classList.remove('d-none');
        targetContainer.style.setProperty('display', 'block', 'important');
        if (explanationInput) explanationInput.setAttribute('required', 'required');
        console.log(`[Medical Engine] Match caught ("1" / Yes). Displaying wrapper box: ${targetContainer.id}`);
      } else {
        // Strip out layout properties, wipe memory values, and hide container elements cleanly
        targetContainer.classList.add('d-none');
        targetContainer.style.setProperty('display', 'none', 'important');
        if (explanationInput) {
          explanationInput.removeAttribute('required');
          explanationInput.value = ''; 
        }
        console.log(`[Medical Engine] Fully suppressed and cleared element wrapper container: ${targetContainer.id} (Value was: "${selectedValue}")`);
      }
    });
  };

  // Run the initialization monitors directly on your targeted HTML items rows
  toggleMedicalSection(medSelect, medDiv, 'explainMed');
  toggleMedicalSection(allergySelect, allergyDiv, 'explainAllergy');
}